module.exports = __webpack_public_path__ + "img/wm-grocery-logo.c0b068cb.jpg";